<template>
  <v-container class="booking-confirm p-0" v-if="subscription">
    <vue-headful :title="$t('header.facility') + $t('title')"></vue-headful>
    <HkiaraceBannerFrame :src="'api/static/'+facilityType.banner"
                         :label="$t('gym_subscription.confirm_msg')">
      <v-container class="booking-confirm-content" fluid>
        <v-row>
          <v-col class="booking-confirm-title text-left">
            {{ $t('booking_confirm.summary') }}
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field :label="$t('gym_subscription.reference_number')"
                          readonly
                          :value="subscription.reference_number.toString().padStart(10, '0')"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field readonly
                          :label="$t('gym_subscription.status')"
                          :value="subscriptionStatus"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field readonly
                          :label="$t('gym_subscription.type')"
                          :value="subscription.type.name"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn color="primary"
                   :to="{name: 'my-account', query: {t: 3}}">
              {{ $t('finish') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </HkiaraceBannerFrame>
  </v-container>
</template>

<script>
  import {library} from '@fortawesome/fontawesome-svg-core'
  import {faChevronCircleLeft} from '@fortawesome/free-solid-svg-icons'
  import HkiaraceBannerFrame from "../../../components/HkiaraceBannerFrame";
  import {computed, onMounted, ref} from "@vue/composition-api";
  import {BOOKING_STATUS_LABEL} from "@/constants";

  library.add(faChevronCircleLeft);

  export default {
    name: 'GymPassConfirm',
    components: {HkiaraceBannerFrame},
    setup(props, {root}) {
      const facilityType = ref(null);
      const getFacilityType = function () {
        root.$callAPI('aafb/gym_subscription/get_facility_type/', {}, function (response) {
          facilityType.value = response.body.facility_type;
        });
      };

      const subscription = ref(null);
      const subscriptionStatus = computed(() => {
        return subscription.value ? root.$t(BOOKING_STATUS_LABEL[subscription.value.status]) : '';
      })
      const getSubscription = function () {
        root.$callAPI('aafb/gym_subscription/', {subscription_id: root.$route.params.subscriptionId}, function (response) {
          subscription.value = response.body.subscription;
        })
      };

      onMounted(() => {
        getFacilityType();
        getSubscription();
      });

      return {
        facilityType,
        subscription,
        subscriptionStatus,
      }
    },
  }
</script>

<style lang="less">
.booking-confirm {
  .booking-confirm-content {
    max-width: 1000px;
    background-color: white;
    padding: 2rem;

    .booking-confirm-title {
      color: #8E765B;
      font-size: 1.5em !important;
    }

    .v-label {
      color: #8E765B;
    }

    .v-text-field > .v-input__control > .v-input__slot:before {
      display: none;
    }

    .v-text-field > .v-input__control > .v-input__slot:after {
      display: none;
    }
  }

  .fa-check-circle {
    font-size: 5em;
  }

  @media (min-width: 992px) {
    font-size: 1.2em;

    .confirm-message-label {
      font-size: 2em !important;
    }

    .booking-summary-title {
      font-size: 2.5em !important;
    }
  }

  .confirm-message-label {
    font-size: 1.5em;
  }

  .booking-summary-title {
    text-align: left;
    font-size: 1.5em;
  }

  .booking-preview-form {
    border: 1px solid rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    padding: 30px;

    .col-form-label {
      color: rgba(0, 0, 0, 0.5);
      text-align: left;
    }
  }
}
</style>
